<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="终端主机号/车牌号/车架号"
             style="width: 200px; margin-right: 3px;"></Input>
<!--      <DatePicker size="small" type="daterange" v-model="selectAnalysisDatetime" placeholder="选择日期"-->
<!--                  style="margin-right: 3px; width: 200px;"></DatePicker>-->
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange"
                 @contextmenu.prevent.native="onTableRightClick($event)" @on-select="onselect" @on-select-all="onselectall"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true"
              show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>
      </div>
    </Row>
    <av-file-list-modal v-model="avFileListModal" :initValue="avFileListModalId"></av-file-list-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                             v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
import { genURLParams } from '@/libs/urlparamhelper'
import MakeAvFileUploadRequestTaskModal
  from '@/view/ddm/components/make-av-file-upload-request-task-modal'
import AvFileListModal
  from '@/view/ddm/components/av-file-list-modal'

export default {
  name: 'avfileuploadrequesttasks',
  components: {
    AvFileListModal
  },
  data () {
    return {

      avFileListModal: false,
      avFileListModalId: null,

      selectAnalysisDatetime: [],

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      stateFilter: null,
      avFileUploadRequestTaskStateFilter: null,

      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '终端主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '车牌',
          resizable: true,
          key: 'registrationNum',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '查询起始时刻',
          resizable: true,
          sortable: 'custom',
          key: 'startDatetime',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.startDatetime) {
              let d = new Date(params.row.startDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '查询结束时刻',
          resizable: true,
          sortable: 'custom',
          key: 'endDatetime',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.endDatetime) {
              let d = new Date(params.row.endDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '请求时刻',
          resizable: true,
          sortable: 'custom',
          key: 'requestDatetime',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.requestDatetime) {
              let d = new Date(params.row.requestDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '应答序列',
          resizable: true,
          key: 'ack',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '回复时刻',
          resizable: true,
          sortable: 'custom',
          key: 'responseDatetime',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.responseDatetime) {
              let d = new Date(params.row.responseDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '回复内容',
          resizable: true,
          key: 'responseContent',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '请求状态',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'state',
          width: 180,
          filters: [
            { label: '请求中', value: 1 },
            { label: '已回复', value: 2 },
            { label: '超时', value: 3 },
            { label: '发送失败', value: 4 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('state', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let state = params.row.state
            if (state === 1) {
              return h('div', '请求中')
            } else if (state === 2) {
              return h('div', '已回复')
            } else if (state === 3) {
              return h('div', '超时')
            } else if (state === 4) {
              return h('div', '发送失败')
            }
          }
        },
        {
          title: '上传文件状态',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'avFileUploadRequestTaskState',
          width: 180,
          filters: [
            { label: '正在上传', value: 2 },
            { label: '转码中', value: 3 },
            { label: '上传成功', value: 4 },
            { label: '发送失败', value: 5 },
            { label: '转码失败', value: 6 },
            { label: '上传失败', value: 7 },
            { label: '上传超时', value: 8 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.avFileUploadRequestTaskStateFilter = []
              val.forEach(item => {
                this.avFileUploadRequestTaskStateFilter.push(genQueryParam('avFileUploadRequestTaskState', 'EQ', item))
              })
            } else {
              this.avFileUploadRequestTaskStateFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let avFileUploadRequestTaskState = params.row.avFileUploadRequestTaskState
            if (avFileUploadRequestTaskState === 2) {
              return h('div', '正在上传')
            } else if (avFileUploadRequestTaskState === 3) {
              return h('div', '转码中')
            } else if (avFileUploadRequestTaskState === 4) {
              return h('div', '上传成功')
            } else if (avFileUploadRequestTaskState === 5) {
              return h('div', '发送失败')
            } else if (avFileUploadRequestTaskState === 6) {
              return h('div', '转码失败')
            } else if (avFileUploadRequestTaskState === 7) {
              return h('div', '上传失败')
            } else if (avFileUploadRequestTaskState === 8) {
              return h('div', '上传超时')
            }
          }
        },
        {
          title: '上传结果',
          resizable: true,
          key: 'result',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '上传文件夹名称',
          resizable: true,
          key: 'uploadFolderName',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: (h, params) => {
            return h('label', {
              on: {
                click: () => {
                  this.avFileListModalId = params.row.id
                  this.avFileListModal = true
                }
              }
            }, params.row.uploadFolderName)
          }
        },
        {
          title: '转码文件夹名称',
          resizable: true,
          key: 'decodeFolderName',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180
        },
        {
          title: '文件数量',
          resizable: true,
          key: 'filesCount',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '文件下载链接',
          resizable: true,
          key: 'downloadFilePath',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '更新时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'updateDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.updateDatetime) {
              let d = new Date(params.row.updateDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'AvFileUploadRequestTaskServ_GetPage'
    ]),
    /**
     * 表格右键回调
     */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
     * 右键菜单点击回调
     */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      this.setPage(1)
    },
    onExportExcelClick () {
      let queryParams = []

      if (this.selectAnalysisDatetime[0] && this.selectAnalysisDatetime[1]) {
        let startDatetime = new Date(this.selectAnalysisDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectAnalysisDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        queryParams.push(genQueryParam('censusDatetime', 'BTDT', startDatetime, endDatetime))
      }
      let urlparams = {
        q: queryParams,
        keyword: this.keywordFilter
      }
      let url = '/api/da/avfileuploadrequesttask/exportexcel' + genURLParams(urlparams)
      window.location.href = url
    },
    filterChange () {
      this.setPage(1)
    },
    onselect (selection, row) {
      this.processAnalysisResultList = []
      selection.forEach(item => {
        this.processAnalysisResultList.push(item.id)
      })
    },
    onselectall (selection) {
      this.processAnalysisResultList = []
      selection.forEach(item => {
        this.processAnalysisResultList.push(item.id)
      })
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let qo1 = null
      let qo2 = null
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('id', false)
      }

      if (this.stateFilter) {
        qo1 = this.stateFilter
      }

      if (this.avFileUploadRequestTaskStateFilter) {
        qo2 = this.avFileUploadRequestTaskStateFilter
      }

      store.dispatch('AvFileUploadRequestTaskServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          qo2: qo2,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_AvFileUploadRequestTask_GetPageResult) {
        return store.getters.get_AvFileUploadRequestTask_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_AvFileUploadRequestTask_GetPageResult) {
        return store.getters.get_AvFileUploadRequestTask_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_AvFileUploadRequestTask_GetPageResult) {
        return store.getters.get_AvFileUploadRequestTask_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
